<template>
  <v-row v-if="lodash.isEmpty(groupedExams)" justify="center">
    <v-col cols="6">
      <v-alert color="orange" outlined text type="info">
        Sem exames
      </v-alert>
    </v-col>
  </v-row>

  <v-row v-else dense>
    <v-col>
      <v-row v-for="(filteredExams, examName) in groupedExams" :key="examName">
        <v-col>
          <v-row dense>
            <v-col class="text-h5 gray--text text--lighten-1">
              {{ examName }}
            </v-col>
          </v-row>

          <v-row dense v-for="(exam, index) in filteredExams" :key="exam.id">
            <v-col>
              <ExamListItem
                :attendance="attendance"
                :attendanceEsigned="attendanceEsigned"
                :exam="exam"
                :index="index"
                :refreshList="refreshList"
                :allowEdit="allowEdit"
                :allowDelete="allowDelete"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  import ExamListItem from "@/components/exam/list/item.vue";

  export default {
    name: "ExamList",
    props: {
      attendance: Object,
      attendanceEsigned: Boolean,
      allowEdit: {
        type: Boolean,
        default: true,
      },
      allowDelete: {
        type: Boolean,
        default: true,
      },
    },
    components: {
      ExamListItem,
    },
    mounted() {
      this.refreshList();
    },
    apollo: {
      exams: {
        query: require("@/graphql/exam/exams.gql"),
        fetchPolicy: 'no-cache',
        variables() {
          return {
            attendanceId: this.attendance.id,
          };
        },
        update(data) {
          return this.lodash.orderBy(data.exams, ["executedAt"], ["desc"]);
        },
        pollInterval: 20000,
      },
    },
    computed: {
      groupedExams() {
        const unordered = this.lodash.groupBy(this.exams, "examTemplate.name");
        const ordered = {};
        Object.keys(unordered)
          .sort()
          .forEach(function(key) {
            ordered[key] = unordered[key];
          });
        return ordered;
      },
    },
    methods: {
      async refreshList() {
        await this.$apollo.queries.exams.refetch();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
